{
  "buttons": {
    "save": "Save",
    "cancel": "Cancel",
    "continue": "Continue",
    "back": "Back",
    "submit": "Submit",
    "delete": "Delete",
    "edit": "Edit",
    "close": "Close",
    "confirm": "Confirm",
    "next": "Next",
    "previous": "Previous",
    "upload": "Upload",
    "download": "Download",
    "refresh": "Refresh",
    "retry": "Retry",
    "learnMore": "Learn More",
    "getStarted": "Get Started",
    "viewDetails": "View Details",
    "saveChanges": "Save Changes"
  },
  "labels": {
    "email": "Email",
    "name": "Name",
    "firstName": "First Name",
    "lastName": "Last Name",
    "phone": "Phone",
    "company": "Company",
    "companyName": "Company Name",
    "country": "Country",
    "address": "Address",
    "city": "City",
    "state": "State",
    "postcode": "Postcode",
    "website": "Website",
    "description": "Description",
    "date": "Date",
    "status": "Status",
    "actions": "Actions",
    "type": "Type",
    "category": "Category",
    "notes": "Notes"
  },
  "status": {
    "loading": "Loading...",
    "saving": "Saving...",
    "success": "Success!",
    "error": "An error occurred",
    "pending": "Pending",
    "completed": "Completed",
    "inProgress": "In Progress",
    "draft": "Draft",
    "active": "Active",
    "inactive": "Inactive"
  },
  "validation": {
    "required": "This field is required",
    "invalidEmail": "Please enter a valid email",
    "minLength": "Must be at least {{min}} characters",
    "maxLength": "Must be no more than {{max}} characters",
    "invalidPhone": "Please enter a valid phone number",
    "invalidUrl": "Please enter a valid URL"
  },
  "errors": {
    "generic": "Something went wrong. Please try again.",
    "network": "Network error. Please check your connection.",
    "unauthorized": "You are not authorised to perform this action.",
    "notFound": "The requested resource was not found.",
    "serverError": "Server error. Please try again later."
  },
  "navigation": {
    "home": "Home",
    "dashboard": "Dashboard",
    "settings": "Settings",
    "profile": "Profile",
    "logout": "Log Out",
    "login": "Log In",
    "signUp": "Sign Up",
    "help": "Help",
    "support": "Support"
  },
  "time": {
    "today": "Today",
    "yesterday": "Yesterday",
    "lastWeek": "Last Week",
    "lastMonth": "Last Month",
    "ago": "ago",
    "minutes": "minutes",
    "hours": "hours",
    "days": "days"
  },
  "language": {
    "select": "Select Language",
    "en": "English",
    "es": "Español",
    "de": "Deutsch",
    "zh": "中文"
  }
}
